import { render } from "./index.vue?vue&type=template&id=3db9cd3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3db9cd3a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/frontend-offical-website/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db9cd3a"]])

export default __exports__